<template>
  <div class="decorate-card">
    <div class="card-body">
      <img v-if="card.image_url" class="card-image" :src="card.image_url" alt="" />
      <div class="card-details">
        <div class="card-title">
          {{ card.title || (isLinkCard ? "装修链接卡" : "三分钟设计你家") }}
        </div>
        <div v-if="card.tags || !isLinkCard" class="card-tags">
          {{ card.tags || "免费设计 | 在线预览" }}
        </div>
        <div v-if="card.button_text || !isLinkCard" class="card-action">
          {{ card.button_text || "立即设计" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    card: { type: Object, required: true },
  },

  computed: {
    isLinkCard() {
      return this.card.format === "ai_decorate_link_card";
    },
  },
});
</script>

<style lang="less" scoped>
.decorate-card {
  width: 100%;
  padding: 12px;
  background: #fff;
  border-radius: 4px;
  color: #4f5a62;
  text-align: left;
  line-height: 20px;
  overflow-wrap: anywhere;

  .card-body {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  img.card-image {
    width: 56px;
    height: 56px;
    flex-shrink: 0;
    object-fit: cover;
    border-radius: 3px;
  }

  .card-details {
    flex: 1;
    min-width: 0;
  }

  .card-title,
  .card-action {
    font-size: 13px;
  }

  .card-tags {
    color: #9e9e9e;
    font-size: 12px;
  }

  .card-action {
    margin-top: 4px;
    color: #2593f4;
  }
}
</style>
